import React, { useRef, useState } from "react";
// Import Swiper React components
import { Bookmark, MapPin } from "react-feather";
import image1 from "../img/program1.png";
import image2 from "../img/program2.png";
import image3 from "../img/program3.png";
import insideimg from "../img/manipal-logo.png";
import { connect } from "react-redux";
import { getProgrammingAction } from "store/Home";
import { Swiper, SwiperSlide } from "swiper/react";
// import Perf from "react-addons-perf"

// Perf.start()
console.time();
class ProgramsOffer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentWillMount() {
    // await this.props.getProgrammingAction()
  }

  render() {
    function addDefaultSrc(ev) {
      ev.target.src = image1;
    }
    return (
      <>
        <div className="my-16">
          <h2 className="fsize28 sm-fsize16  mb-8 font-bold">
            PROGRAMS WE OFFER
          </h2>
          <div>
            <Swiper
              breakpoints={{
                1366: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                991: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
                420: {
                  slidesPerView: 2,
                  spaceBetween: 15,
                },
                375: {
                  slidesPerView: 2,
                  spaceBetween: 15,
                },
              }}
              spaceBetween={30}
              slidesPerGroup={4}
              loop={true}
              loopFillGroupWithBlank={true}
              pagination={{
                clickable: true,
              }}
              navigation={false}
              className="mySwiper swiperpagination-dot"
            >
              {this.props.getProgramming &&
                this.props.getProgramming.Data &&
                this.props.getProgramming.Data.map(function (data, index) {
                  if (index < 4) {
                    return (
                      <SwiperSlide className="shadow-lg rounded-12px mb-4 showcard " key={index}>
                        {/* <Swiper
        slidesPerView={3}
        spaceBetween={30}
        slidesPerGroup={3}
        loop={true}
        loopFillGroupWithBlank={true}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        className="mySwiper swiperpagination-dot"
      > */}

                        <SwiperSlide className="shadow-lg rounded-b-lg   showcard">
                          <card className="relative w-full">
                            <div className="img__wrap">
                              <div>
                                <img
                                  onError={addDefaultSrc}
                                  src={
                                    process.env.REACT_APP_IMAGE_BASE_MG +
                                    "/" +
                                    data.p_path
                                  }
                                  alt="quiz"
                                  className="w-full h-438px sm-h180px rounded-12px"
                                />
                                <h1 className="program-inside-t">
                                  {" "}
                                  {data.p_title}
                                </h1>
                              </div>
                              <div className="img__description_layer text-center shadow-lg rounded-lg lg:p-8 md:p-8 p-2">
                                <p className="text-black font-semibold sm-fsize12  fsize28">
                                  {data.p_title}
                                </p>

                                <div className="lg:mt-6 md:mt-6 mt-2">
                                  <p className="cust-textmuted1 sm-fsize10 font-medium fsize18 ">
                                    Partnered with
                                  </p>
                                  <div className="flex justify-center lg:mt-3 md:mt-3 mt-2 lg:mb-12 md:mb-12 mb-2">
                                    <img
                                      src={insideimg}
                                      alt="logo"
                                      className="inside-logo-w"
                                    />
                                  </div>
                                </div>

                                <div className="lg:mb-6 md:mb-6 mb-2">
                                  <p className="cust-textmuted1 fsize16 mb-2 sm-fsize10">
                                    Duration:
                                    <span className="text-black  ml-2">
                                      1 years (Full Time)
                                    </span>
                                  </p>
                                  <p className="cust-textmuted1 fsize16  sm-fsize10">
                                    Location:
                                    <span className="text-black  ml-2">
                                      New Delhi, Mumbai
                                    </span>
                                  </p>
                                </div>

                                <div className="flex justify-center">
                                  <button className="cust-programoffer-btn flex">
                                    APPLY NOW
                                  </button>
                                </div>
                              </div>
                            </div>
                          </card>
                        </SwiperSlide>
                        {/* </Swiper> */}
                        {/*
             <card className="relative">
              <div className="img__wrap">
                <div>
                  <img src={image1} className="" />
                  <h1 className="program-inside-t">Sales Management Programme</h1>
                </div>
                <div className="img__description_layer text-center shadow-lg rounded-lg p-8">
                  <p className="text-black font-semibold  fsize28">
                    Sales Management Programme
                  </p>
  
                  <div className="mt-6">
                    <p className="cust-textmuted1 font-medium fsize18 ">
                      Partnered with
                    </p>
                    <div className="flex justify-center mt-3 mb-12">
                      <img src={insideimg} className="inside-logo-w" />
                    </div>
                  </div>
  
                  <div className="mb-6">
                    <p className="cust-textmuted1 fsize16 mb-2 sm-fsize12">
                      Duration:
                      <span className="text-black  ml-2">
                        1 years (Full Time)
                      </span>
                    </p>
                    <p className="cust-textmuted1 fsize16 ">
                      Location:
                      <span className="text-black  ml-2">New Delhi, Mumbai</span>
                    </p>
                  </div>
  
                  <div className="flex justify-center">
                    <button className="cust-programoffer-btn flex">
                      APPLY NOW
                    </button>
                  </div>
                </div>
              </div>
            </card>
  
            <card className="relative">
              <div className="img__wrap">
                <div>
                  <img src={image2} className="" />
                  <h1 className="program-inside-t">
                    Probationary Officer Programme
                  </h1>
                </div>{" "}
                <div className="img__description_layer text-center shadow-lg rounded-lg p-8">
                  <p className="text-black font-semibold  fsize28">
                    Probationary Officer Programme
                  </p>
  
                  <div className="mt-6">
                    <p className="cust-textmuted1 font-medium fsize18 ">
                      Partnered with
                    </p>
                    <div className="flex justify-center mt-3 mb-12">
                      <img src={insideimg} className="inside-logo-w" />
                    </div>
                  </div>
  
                  <div className="mb-6">
                    <p className="cust-textmuted1 fsize16 mb-2 sm-fsize12">
                      Duration:
                      <span className="text-black  ml-2">
                        1 years (Full Time)
                      </span>
                    </p>
                    <p className="cust-textmuted1 fsize16 ">
                      Location:
                      <span className="text-black  ml-2">New Delhi, Mumbai</span>
                    </p>
                  </div>
  
                  <div className="flex justify-center">
                    <button className="cust-programoffer-btn flex">
                      APPLY NOW
                    </button>
                  </div>
                </div>
              </div>
            </card>
  
            <card className="relative">
              <div className="img__wrap">
                <div>
                  <img src={image2} className="" />
                  <h1 className="program-inside-t">
                    Business Leadership Programme
                  </h1>
                </div>{" "}
                <div className="img__description_layer text-center shadow-lg rounded-lg p-8">
                  <p className="text-black font-semibold  fsize28">
                    Business Leadership Programme
                  </p>
  
                  <div className="mt-6">
                    <p className="cust-textmuted1 font-medium fsize18 ">
                      Partnered with
                    </p>
                    <div className="flex justify-center mt-3 mb-12">
                      <img src={insideimg} className="inside-logo-w" />
                    </div>
                  </div>
  
                  <div className="mb-6">
                    <p className="cust-textmuted1 fsize16 mb-2 sm-fsize12">
                      Duration:
                      <span className="text-black  ml-2">
                        1 years (Full Time)
                      </span>
                    </p>
                    <p className="cust-textmuted1 fsize16 ">
                      Location:
                      <span className="text-black  ml-2">New Delhi, Mumbai</span>
                    </p>
                  </div>
  
                  <div className="flex justify-center">
                    <button className="cust-programoffer-btn flex">
                      APPLY NOW
                    </button>
                  </div>
                </div>
              </div>
            </card> */}
                      </SwiperSlide>
                    );
                  }
                })}
            </Swiper>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    getProgramming: state.Home.home.GETPROGRAMMING,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getProgrammingAction: async () => await dispatch(getProgrammingAction()),
  };
};
// import {  } from "../../../store/Home"
export default connect(mapStateToProps, mapDispatchToProps)(ProgramsOffer);
console.timeEnd();
